








































import { Validator } from 'vee-validate'
import { Component, Inject, Prop, PropSync, Vue } from 'vue-property-decorator'

import AddressForm from '@spa/components/organisms/profile/AddressForm.vue'
import { AddressFormState } from '@spa/components/organisms/profile/addressFormState'
import NameForm from '@spa/components/organisms/profile/NameForm.vue'
import { NameFormState } from '@spa/components/organisms/profile/nameFormState'
import TelForm from '@spa/components/organisms/profile/TelForm.vue'
import { AddressFieldsEnabledState } from '@spa/components/pages/mypage/edit/contact/interaction'

@Component({
  components: {
    NameForm,
    AddressForm,
    TelForm,
  },
})
export default class ContactForm extends Vue {
  @Inject()
  $validator: Validator

  @PropSync('nameForm', { type: Object, required: true })
  nameFormState: NameFormState

  @PropSync('addressForm', { type: Object, required: true })
  addressFormState: AddressFormState

  @PropSync('tel', { type: String, required: true })
  telVal: string

  @Prop({ required: true })
  addressFieldsEnabledState: AddressFieldsEnabledState
}
